var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.videoVisible,"show-close":true,"width":"670px","append-to-body":""},on:{"close":_vm.closeVideo}},[_c('video',{ref:"videoRef",staticStyle:{"display":"block","background-color":"black"},attrs:{"width":"100%","height":"400px","controls":"","src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }